(function () {
  'use strict';

  var STORAGE_KEY = '_fc_full_page_context';
  var SESSION_KEY = '_fc_full_page_session';
  var PARAMS = {
    experimentId: '_fce',
    funnelId: '_fcf',
    stepId: '_fcs',
    variantId: '_fcv',
    visitorKey: '_fck'
  };

  function validId(value) {
    return /^[a-f0-9-]{20,64}$/i.test(String(value || ''));
  }

  function validVisitorKey(value) {
    return /^[A-Za-z0-9_-]{8,120}$/.test(String(value || ''));
  }

  function readContext() {
    var url = new URL(window.location.href);
    var fromUrl = {
      experimentId: url.searchParams.get(PARAMS.experimentId),
      funnelId: url.searchParams.get(PARAMS.funnelId),
      stepId: url.searchParams.get(PARAMS.stepId),
      variantId: url.searchParams.get(PARAMS.variantId),
      visitorKey: url.searchParams.get(PARAMS.visitorKey)
    };
    var complete = validId(fromUrl.experimentId)
      && validId(fromUrl.funnelId)
      && validId(fromUrl.stepId)
      && validId(fromUrl.variantId)
      && validVisitorKey(fromUrl.visitorKey);

    if (complete) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl));
      Object.keys(PARAMS).forEach(function (key) {
        url.searchParams.delete(PARAMS[key]);
      });
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      return fromUrl;
    }

    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (stored
        && validId(stored.experimentId)
        && validId(stored.funnelId)
        && validId(stored.stepId)
        && validId(stored.variantId)
        && validVisitorKey(stored.visitorKey)) {
        return stored;
      }
    } catch (_) {
      localStorage.removeItem(STORAGE_KEY);
    }
    return null;
  }

  function sessionId() {
    var value = sessionStorage.getItem(SESSION_KEY);
    if (value) return value;
    value = 's_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
    sessionStorage.setItem(SESSION_KEY, value);
    return value;
  }

  function persistCartAttribution(context) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _fc_experiment_id: context.experimentId,
          _fc_funnel_id: context.funnelId,
          _fc_step_id: context.stepId,
          _fc_variant_id: context.variantId,
          _fc_visitor_key: context.visitorKey
        }
      })
    }).catch(function () {});
  }

  function trackView(context) {
    var params = new URLSearchParams(window.location.search);
    return fetch('/apps/funnels/api/track', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event: 'page_view',
        funnelId: context.funnelId,
        stepId: context.stepId,
        variantId: context.variantId,
        visitorId: context.visitorKey,
        explicitEventKey: 'full-page-view:' + context.experimentId + ':' + context.visitorKey + ':' + sessionId(),
        pathFingerprint: window.location.pathname,
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        payload: {
          experimentId: context.experimentId,
          destinationPath: window.location.pathname
        }
      })
    }).catch(function () {});
  }

  function trackCtaClick(context, ctaId) {
    return fetch('/apps/funnels/api/track', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event: 'cta_click',
        funnelId: context.funnelId,
        stepId: context.stepId,
        variantId: context.variantId,
        visitorId: context.visitorKey,
        explicitEventKey: 'full-page-cta:' + context.experimentId + ':' + context.visitorKey + ':' + sessionId() + ':' + ctaId,
        pathFingerprint: window.location.pathname,
        payload: {
          experimentId: context.experimentId,
          ctaId: ctaId,
          destinationPath: window.location.pathname
        }
      })
    }).catch(function () {});
  }

  function bindCtaTracking(context) {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('#mainCheckout, #stickyCtaBtn')
        : null;
      if (!target) return;
      trackCtaClick(context, target.id || 'checkout');
    }, true);
  }

  var context = readContext();
  if (!context) return;

  localStorage.setItem('_fv', context.visitorKey);
  document.cookie = '_fv=' + encodeURIComponent(context.visitorKey) + '; Path=/; Max-Age=31536000; SameSite=Lax';
  document.cookie = '_funnel_context=' + encodeURIComponent(JSON.stringify({
    visitorId: context.visitorKey,
    funnelId: context.funnelId,
    stepId: context.stepId,
    variantId: context.variantId,
    experimentId: context.experimentId
  })) + '; Path=/; Max-Age=2592000; SameSite=Lax';

  persistCartAttribution(context);
  trackView(context);
  bindCtaTracking(context);
})();

// Keep the live mobile purchase bar available until an inline purchase CTA is visible.
(function () {
  'use strict';

  if (window.__novaHairLiveStickyVisibilityFix) return;
  window.__novaHairLiveStickyVisibilityFix = true;

  function init() {
    var root = document.querySelector('.nova');
    var sticky = document.getElementById('stickyBuyBar');
    var drawer = document.querySelector('cart-drawer');
    if (!root || !sticky || !sticky.classList.contains('nh-sticky-v3')) return;

    var style = document.createElement('style');
    style.id = 'novahair-live-sticky-cache-fix';
    style.textContent = '@media(max-width:749px){html body .nova.nh-sticky-live-space{padding-bottom:202px!important}html body .nova #stickyBuyBar.nh-sticky-v3.nh-sticky-live-force-visible:not(.nh-sticky-live-inline-hidden){visibility:visible!important;opacity:1!important;pointer-events:auto!important;transform:translateY(0)!important}html body .nova #stickyBuyBar.nh-sticky-v3.nh-sticky-live-inline-hidden{visibility:hidden!important;opacity:0!important;pointer-events:none!important;transform:translateY(110%)!important}}';
    document.head.appendChild(style);

    var inlineCtas = Array.prototype.slice.call(document.querySelectorAll(
      '#mainCheckout, .nh-midpage-cta__button, .nh-reentry-desktop .btn-primary-cta, .nh-reentry-mobile'
    ));
    var visibleInlineCtas = new Set();

    function sync() {
      var mobile = window.innerWidth <= 749;
      var cartOpen = Boolean(drawer && drawer.classList.contains('active'));
      var shouldHide = !mobile || cartOpen || visibleInlineCtas.size > 0;
      sticky.classList.toggle('nh-sticky-live-inline-hidden', shouldHide);
      sticky.classList.toggle('nh-sticky-live-force-visible', !shouldHide);
      root.classList.toggle('nh-sticky-live-space', !shouldHide);
      window.requestAnimationFrame(function () {
        sticky.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      });
    }

    if ('IntersectionObserver' in window && inlineCtas.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visibleInlineCtas.add(entry.target);
          else visibleInlineCtas.delete(entry.target);
        });
        sync();
      }, { threshold: 0.15 });
      inlineCtas.forEach(function (cta) { observer.observe(cta); });
    }

    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(drawer, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
